import { erpAxios } from '..';

const getRacuni = async (clientId) => {
  const { data } = await erpAxios.get(`/racuni/${clientId}`);
  return data;
};

export default getRacuni;
